module.exports = __webpack_public_path__ + "static/bot2-bc932291732c388da0f15a398a83ae41.jpg";